import { GenericValue } from 'hisng';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HisBaseGlobalsService } from 'hisng';
import {
    ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER,
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_FORMAT_PLACEHOLDER,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';
import { TravelData } from '../../model/traveldata';

@Component( {
    selector: 'erp-businesstripapplication-traveldata',
    templateUrl: './businesstripapplication-traveldata.component.html'
} )
export class BusinesstripApplicationTraveldataComponent implements OnInit {
    @Input() travelData: TravelData = new TravelData();
    @Output() readonly travelDataChange = new EventEmitter<TravelData>();
    readonly dateTimeFormat: string;
    readonly datePlaceholderFormat: string;

    constructor(
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
    ) {
        if ( this.hisBaseGlobalsService.getLanguage() === 'de' ) {
            this.dateTimeFormat = GERMAN_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = GERMAN_DATE_TIME_FORMAT_PLACEHOLDER;
        } else {
            this.dateTimeFormat = ENGLISH_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER;
        }
    }

    ngOnInit(): void {
    }

    onModelChange( changedValue: string | Date | GenericValue ): void {
        this.travelDataChange.emit( this.travelData );
    }
}
